/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://gdm2ipe7tzglfh2kv3tvhv3fki.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-uvpvxlwxhbfdho5axqslgopqni",
    "aws_cognito_identity_pool_id": "us-west-2:182427d1-1791-4c19-9ca9-bf2b306e655e",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_XEhEW3MlE",
    "aws_user_pools_web_client_id": "6rfo2mq7r0ri8fos2fjuvdi9kb",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
